





























import {Component, Prop, Vue} from "vue-property-decorator";
import {CustomerBalance} from "@/interfaces/entities/CustomerProfile";

@Component
export default class PackageQueueCard extends Vue {
    @Prop({type: Array, default: () => []}) queuedBalances!: Array<CustomerBalance>;

    private countryNameFor(countrySet: string): string {
        return this.$options.filters?.countryName ? (this.$options.filters.countryName(countrySet) as string) : countrySet;
    }
}
